// extracted by mini-css-extract-plugin
module.exports = {"bg_none":"LoginForm_bg_none__2uRfM","close-modal":"LoginForm_close-modal__1CvF-"};